import React, { useEffect, useState } from "react";
import userServiceApi from "../../../api/userServiceApi";
import { postRequest } from "../../../api/http";
import "../Onboarding/Onboarding.scss";
import {
  getAuthToken,
  getRefreshToken,
  setAuthToken,
  setRefreshToken,
} from "../../../utils/helper";
import {
  getStripeRedirectUrl,
  isStripeExpressRedirectUrl,
} from "../../../utils/stripeOnboarding";

const PAYMENT_HISTORY_URL_KEY = "stripePaymentHistoryUrl";

const PaymentHistory = () => {
  const [paymentHistoryUrl, setPaymentHistoryUrl] = useState("");
  const [loadingLink, setLoadingLink] = useState(true);

  useEffect(() => {
    const fetchPaymentHistoryUrl = async () => {
      const cachedUrl = sessionStorage.getItem(PAYMENT_HISTORY_URL_KEY);
      if (isStripeExpressRedirectUrl(cachedUrl)) {
        setPaymentHistoryUrl(cachedUrl);
        setLoadingLink(false);
        return;
      }

      const connectedAccountId = sessionStorage.getItem("connectedAccountId");
      if (!connectedAccountId) {
        setLoadingLink(false);
        return;
      }

      try {
        const stripeResponse = await postRequest(
          userServiceApi.getStripeLoginLink(connectedAccountId)

        );
        const url = getStripeRedirectUrl(stripeResponse);
        if (isStripeExpressRedirectUrl(url)) {
          sessionStorage.setItem(PAYMENT_HISTORY_URL_KEY, url);
          setPaymentHistoryUrl(url);
        }
      } catch (error) {
        console.log("Stripe payment history link error----->", error);
      } finally {
        setLoadingLink(false);
      }
    };

    fetchPaymentHistoryUrl();
  }, []);

  const handleViewPaymentHistory = () => {
    if (!isStripeExpressRedirectUrl(paymentHistoryUrl)) return;

    const token = getAuthToken();
    const refresh = getRefreshToken();
    if (token) setAuthToken(token);
    if (refresh) setRefreshToken(refresh);
    window.open(paymentHistoryUrl, "_blank", "noopener,noreferrer");
  };

  const connectedAccountId = sessionStorage.getItem("connectedAccountId");

  return (
    <div className="onboarding-page">
      <div className="onboarding-container">
        <div className="onboarding-icon">
          <span>$</span>
        </div>

        <h1>Payment History</h1>

        <p className="onboarding-description">
          To view the payment history, please click on the link below.
        </p>

        <button
          type="button"
          className="onboarding-button"
          onClick={handleViewPaymentHistory}
          disabled={loadingLink || !paymentHistoryUrl || !connectedAccountId}
        >
          {loadingLink ? "Loading..." : "View Payment History"}
        </button>

        <p className="onboarding-link-text">
          You will be redirected to Stripe to view your payment history.
        </p>
      </div>
    </div>
  );
};

export default PaymentHistory;
